export const menuItems = [
  {
    label: 'Επικύρωση Συνταγών',
    icon: 'pi pi-receipt',
    routerLink: '/prescriptions',
    roles: ['Admin', 'Pharmacist', 'ResponsiblePharmacist', 'Employee'],
    permissions: ['PRESCRIPTIONS_VIEW'],
  },
  {
    label: 'Επικυρωμένες Συνταγές',
    icon: 'pi pi-check-circle',
    routerLink: '/prescriptions/verified',
    permissions: ['PRESCRIPTIONS_VIEW'],
  },
  // {
  //   label: 'Επαλήθευση OTP',
  //   icon: 'pi pi-key',
  //   routerLink: '/otp-verification/request',
  //   roles: ['Admin', 'Pharmacist', 'Employee'],
  //   permissions: ['OTP_REQUEST', 'OTP_VALIDATE'],
  // },
  // {
  //   label: 'Επικύρωση με Έγγραφο',
  //   icon: 'pi pi-upload',
  //   routerLink: '/documents',
  //   roles: ['Admin', 'Pharmacist', 'Employee'],
  //   permissions: ['DOCUMENTS_UPLOAD'],
  // },
  {
    label: 'Χρήστες Φαρμακείου',
    icon: 'pi pi-users',
    routerLink: '/user/search',
    roles: ['Pharmacist', 'ResponsiblePharmacist'],
    permissions: ['USER_MANAGEMENT'],
  },
  // {
  //   label: 'Διαχείριση Χρηστών',
  //   icon: 'pi pi-users',
  //   routerLink: '/user/search',
  //   roles: ['Admin'],
  //   permissions: ['users'],
  // },
  // {
  //   label: 'Ρόλοι',
  //   icon: 'pi pi-sitemap',
  //   routerLink: '/roles',
  //   roles: ['Admin'],
  //   permissions: ['ROLE_MANAGEMENT'],
  // },
  // {
  //   label: 'Αρχείο Επικυρώσεων',
  //   icon: 'pi pi-history',
  //   routerLink: '/admin/audit',
  //   roles: ['Admin'],
  //   permissions: ['ADMIN_VIEW'],
  // },
  {
    label: 'Επικοινωνία',
    icon: 'pi pi-envelope',
    routerLink: '/contact',
    roles: ['Admin', 'Pharmacist', 'ResponsiblePharmacist', 'Employee'],
    permissions: ['CONTACT'],
  },
  {
    label: 'Ρυθμίσεις',
    icon: 'pi pi-cog',
    routerLink: '/settings',
    roles: ['Admin', 'Pharmacist', 'ResponsiblePharmacist', 'Employee'],
    permissions: ['SETTINGS_UPDATE'],
  },
  {
    label: 'Επικυρωμένες Συνταγές (Όλα)',
    icon: 'pi pi-check-circle',
    routerLink: '/admin/verifications',
    roles: ['Admin'],
    permissions: ['ADMIN_VIEW'],
  },
  {
    label: 'Αρχείο Ελέγχου',
    icon: 'pi pi-history',
    routerLink: '/admin/audit-logs',
    roles: ['Admin'],
    permissions: ['ADMIN_VIEW'],
  },
  {
    label: 'Κατάσταση Υγείας',
    icon: 'pi pi-heart',
    routerLink: '/admin/health',
    roles: ['Admin'],
    permissions: ['ADMIN_VIEW'],
  },
  {
    label: 'Μετρήσεις Απόδοσης',
    icon: 'pi pi-chart-line',
    routerLink: '/admin/performance-metrics',
    roles: ['Admin'],
    permissions: ['ADMIN_VIEW'],
  },
  {
    label: 'Στατιστικά Απόδοσης',
    icon: 'pi pi-chart-bar',
    routerLink: '/admin/performance-statistics',
    roles: ['Admin'],
    permissions: ['ADMIN_VIEW'],
  },
];
